import { render, staticRenderFns } from "./customer-list.vue?vue&type=template&id=4123ac2d&scoped=true&"
import script from "./customer-list.vue?vue&type=script&lang=ts&"
export * from "./customer-list.vue?vue&type=script&lang=ts&"
import style0 from "./customer-list.vue?vue&type=style&index=0&id=4123ac2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4123ac2d",
  null
  
)

export default component.exports